import * as React from 'react'
import Confetti from 'react-confetti'
import { usePreviousACStatus } from '../hooks'

export const ActionCenterConfetti = () => {
  const { status, previousStatus } = usePreviousACStatus()

  return <>{status === 'all_completed' && previousStatus === 'show' && <Confetti recycle={false} />}</>
}
